import { render, staticRenderFns } from "./CalendarComponent2.vue?vue&type=template&id=5e0dea71&scoped=true&"
import script from "./CalendarComponent2.vue?vue&type=script&lang=ts&"
export * from "./CalendarComponent2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0dea71",
  null
  
)

export default component.exports